function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    .ant-collapse-header {\n      display: none;\n    }\n    && .ant-collapse-content-box {\n      // remove the default indentation\n      padding: 0px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { Collapse as AntCollapse } from "antd";
import React from "react";
import styled from "styled-components";
var Panel = AntCollapse.Panel;
var Collapse = styled(AntCollapse)(_templateObject());
var UnstyledCollapse = function(param) {
    var children = param.children, _param_condition = param.condition, condition = _param_condition === void 0 ? false : _param_condition, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style;
    return /*#__PURE__*/ React.createElement(Collapse, {
        activeKey: condition ? "1" : null,
        ghost: true,
        destroyInactivePanel: true
    }, /*#__PURE__*/ React.createElement(Panel, {
        key: "1",
        style: style,
        header: null
    }, children));
};
export default UnstyledCollapse;
